import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CardBody, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Input, Label, Card, FormGroup, Alert, Button } from "reactstrap";
import UserContext from "../../../context/UserContext";
import { Role } from "../../../models/Role";
import { VideoChatService } from "../../../services/VideoChatService";
import { toast } from "react-toastify";
import AiIcon from "../../../assets/images/icons/AI_animation_logo.gif";
import AIGeneratedNote from "./AIGenratedNote";
import deleteIcon from "../../../assets/images/icons8-delete.svg";
import Swal from "sweetalert2";
import NoteShareTherapistModal from "src/pages/Popup/NoteShareTherapistModal";
import { TreatmentHistory } from "src/models/TreatmentHistory";
import { AINotesType } from "src/models/Therapist";
import NoteTypeSelectModal from "src/pages/Popup/NoteTypeSelectionModal";
import AIGeneratePieNoteNew from "./AIGeneratePieNoteNew";
import DiagnosisNoteVersionModal from "src/pages/Popup/DiagnosisNoteVersionModal";
import { Spinner } from "reactstrap";

interface TranscribeHistoryCardProps {
  transcribeData: any;
  isCreating: boolean;
  selectedTreatmentHistoryForMerge: any;
  setSelectedTreatmentHistoryForMerge: any;
  setSelectedClient: any;
  showDiagnosisFunction: (diagnosisNoteId: string, totalSpentDuration: number, noteTypeFrom: string, isVersion: boolean) => void;
  showAudioFunction: (audioId: string, path: string, showAudio: boolean) => void;
  //  showAudioFunction: (audioId: string, showAudio: boolean) => void;
  showTranscribeFunction: (transcribeId: string) => void;
  updateDiagnosisData: (isUpdate: boolean) => void;
  onShareWithSubTherapy: (value: TreatmentHistory) => void;
  saveNewNote: (transcribeData: any, noteType: string) => void;
}

const TranscribeHistoryCard: React.FC<TranscribeHistoryCardProps> = props => {
  const [user] = useContext(UserContext);
  const [transcribeInProcess, setTranscribeInProcess] = useState(false);
  const mounted = useRef(false);

  const [openShareModal, setOpenShareModal] = useState(false);
  const [showTypeSelectModal, setShowTypeSelectModal] = useState(false);
  const [showPIENote, setShowPIENote] = useState(false);
  const [showAiGeneratedPopup, setShowAiGeneratedPopup] = useState<boolean>(false);
  const [showTestModal, setShowTestModal] = useState<boolean>(false);
  const [transcriptData, setTranscriptData] = useState<string[]>([]);
  const [speakerMapping, setSpeakerMapping] = useState<{ [key: string]: string }>({});
  const [isLoadingTranscript, setIsLoadingTranscript] = useState<boolean>(false);
  const [validationError, setValidationError] = useState<string>("");
  const [isMappingSubmitted, setIsMappingSubmitted] = useState<boolean>(false);
  const [isSubmittingMapping, setIsSubmittingMapping] = useState<boolean>(false);
  const [availableNames, setAvailableNames] = useState<string[]>([]);
  const [memberDetails, setMemberDetails] = useState<any[]>([]);
  const [groupMembers, setGroupMembers] = useState<any[]>([]);
  const [transcribeId, setTranscribeId] = useState<string>("");

  const [showTypeSelectModalForViewEdit, setShowTypeSelectModalForViewEdit] = useState(false);
  const [diagnosisNoteWithVersionsData, setDiagnosisNoteWithVersionsData] = useState<any>();
  const [showDiagnosisNoteWithVersionModal, setShowDiagnosisNoteWithVersionModal] = useState(false);

  // Default available names for mapping (fallback)
  const defaultAvailableNames = [
    "Dr. Sarah Johnson (Therapist)",
    "Emily Chen (Client)",
    "Michael Chen (Family Member)"
  ];

  useEffect(() => {
    props.setSelectedClient(props.transcribeData.clientId);

    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (diagnosisNoteWithVersionsData) {
      setShowDiagnosisNoteWithVersionModal(true);
    }
  }, [diagnosisNoteWithVersionsData]);

  const createTranscriptText = (meetingId: string) => {
    setTranscribeInProcess(true);

    VideoChatService.createTranscriptText(meetingId).then(res => {
      if (!res.success) {
        if (mounted) {
          setTranscribeInProcess(false);

          if (res.error && res.errorCode && res.errorCode == 600) {
            toast.success("Recordings of meeting are still processing.Please try again shortly", {
              position: toast.POSITION.TOP_RIGHT,
              className: "foo-bar",
            });
          } else {
            toast.error("Server error occured", {
              position: toast.POSITION.TOP_RIGHT,
              className: "foo-bar",
            });
          }
        }
      }
    });
  };

  const handleCheckBoxChange = (e: any) => {
    const id: string = e.target.name;

    if (props.selectedTreatmentHistoryForMerge.includes(id)) {
      if (!e.target.value) {
        props.setSelectedTreatmentHistoryForMerge((prev: any[]) => {
          return [...prev.filter((item, i) => item !== id)];
        });
      }
    } else {
      props.setSelectedTreatmentHistoryForMerge([...props.selectedTreatmentHistoryForMerge, id]);
    }
  };
  // const handleClickedAiGenerate = (boolean: boolean) => {
  //   setShowAiGeneratedPopup(boolean);
  // };

  const handleChildFunction = (isCalled: boolean) => {
    setShowAiGeneratedPopup(isCalled);
  };

  const saveNote = (transcribeData: any, noteType: string) => {
    console.log("B");
    console.log("transcribeData", transcribeData);
    props.saveNewNote(transcribeData, noteType);
  };

  const deleteDiagnosisNoteCode = (e: any) => {
    const diagnosisNoteId = e.currentTarget.getAttribute("data-value1");
    Swal.fire({
      icon: "info",
      title: "Are you sure want to delete this treatment history?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#50a5f1",
      cancelButtonText: "No",
      cancelButtonColor: "#f46a6a",
    }).then(result => {
      if (result.isConfirmed) {
        const data = {
          noteId: diagnosisNoteId,
        };

        VideoChatService.deleteTreatmentHistoryByTherapist(data).then(res => {
          if (res.success) {
            props.updateDiagnosisData(true);
            toast.success(res.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
            });
          } else {
            toast.error(res.error, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
            });
          }
        });
      }
    });
  };
  const handleOpenShareNote = () => {
    setOpenShareModal(true);
  };

  const onShare = (data: TreatmentHistory) => {
    setOpenShareModal(false);
    props?.onShareWithSubTherapy(data);
  };

  const slectTypeFunction = (type: string, showModal: boolean) => {
    setShowTypeSelectModal(showModal);

    if (type && (type == AINotesType.PIE || type == AINotesType.SOAP)) {
      if (type == AINotesType.SOAP) {
        setShowAiGeneratedPopup(true);
      } else {
        setShowPIENote(true);
      }
    }
  };

  const openDiagnosisNoteInitial = () => {
    const noteDetails = props?.transcribeData?.diagnosisNoteDetails;

    if (!noteDetails?.noteType && noteDetails?.updatedByTherapist) {
      openDiagnosisNote(AINotesType.SOAP);
    } else if (!user?.aiNotesType && noteDetails?.noteType) {
      openDiagnosisNote(noteDetails?.noteType);
    } else if (user?.aiNotesType && noteDetails?.noteType) {
      openDiagnosisNote(noteDetails?.noteType);
    } else if (!noteDetails?.noteType && user?.aiNotesType) {
      openDiagnosisNote(user?.aiNotesType);
    } else {
      setShowTypeSelectModalForViewEdit(true);
    }
  };

  const openDiagnosisNote = (noteTypeFrom: string) => {
    if (props.transcribeData.isMeetingTranscribe) {
      let totalSpentDuration = 0;

      if (props.transcribeData.mergedMeetings && props.transcribeData.mergedMeetings.length > 0) {
        props.transcribeData.mergedMeetings.map((v: any) => {
          totalSpentDuration = totalSpentDuration + v.spentDuration;
        });
      } else {
        totalSpentDuration = props.transcribeData.meetingId.spentDuration;
      }

      props.showDiagnosisFunction(props.transcribeData.diagnosisNoteId, totalSpentDuration, noteTypeFrom, false);
    }
  };

  const slectTypeFunctionForViewEdit = (type: string, showModal: boolean) => {
    setShowTypeSelectModalForViewEdit(showModal);

    if (type && (type == AINotesType.PIE || type == AINotesType.SOAP)) {
      openDiagnosisNote(type);
    }
  };

  const genarateAiNoteFunction = () => {
    const noteType = props?.transcribeData?.diagnosisNoteDetails?.noteType;
    const userNoteType = user?.aiNotesType;
    if (noteType) {
      if (noteType === "PIE") {
        setShowPIENote(true);
      } else {
        setShowAiGeneratedPopup(true);
      }
    } else if (!noteType && userNoteType) {
      if (userNoteType === "PIE") {
        setShowPIENote(true);
      } else {
        setShowAiGeneratedPopup(true);
      }
    } else {
      setShowTypeSelectModal(true);
    }
  };

  const closePIENoteFunction = (value: boolean) => {
    setShowPIENote(value);
  };

  const savePIENote = (transcribeData: any) => {
    // props.saveNewNote(transcribeData);
  };

  const handleModalClose = () => {
    setShowDiagnosisNoteWithVersionModal(false);
    setDiagnosisNoteWithVersionsData(null);
  };

  const handleTestClick = async () => {
    setShowTestModal(true);
    await loadTranscriptData();
  };

  const closeTestModal = () => {
    setShowTestModal(false);
    setTranscriptData([]);
    setSpeakerMapping({});
    setValidationError("");
    setIsMappingSubmitted(false);
    setAvailableNames([]);
    setMemberDetails([]);
    setGroupMembers([]);
    setTranscribeId("");
  };

  const getMockTranscriptData = () => {
    return [
      "user1: Hello, how are you feeling today?",
      "user2: I've been feeling quite anxious lately, especially about work.",
      "user1: Can you tell me more about what specifically at work is causing you anxiety?",
      "user2: Well, I have this big presentation coming up next week and I keep worrying about it.",
      "user3: Mom, you always worry too much about these things.",
      "user2: I know, but I can't help it. The last time I presented, it didn't go well.",
      "user1: It sounds like you're carrying some past experiences into this new situation. That's very common.",
      "user2: Yes, exactly. I keep thinking about all the things that could go wrong.",
      "user1: Let's work on some techniques to help manage those anxious thoughts. Have you tried breathing exercises?",
      "user2: A little bit, but I'm not sure I'm doing them correctly.",
      "user3: I can help you practice at home if you want.",
      "user1: That's wonderful support. Family involvement can be very helpful in managing anxiety.",
      "user2: Thank you both. I really appreciate the help.",
      "user1: We'll continue working on this together. How does that sound?",
      "user2: That sounds great. I'm feeling a bit more hopeful already."
    ];
  };

  const loadTranscriptData = async () => {
    setIsLoadingTranscript(true);

    // Try to load real transcript data using meetingId
    if (props?.transcribeData?.meetingId?.meetingId) {
      try {
        const response = await VideoChatService.getTranscribesByMeetingId(props.transcribeData.meetingId.meetingId);
        if (response.success && response.data && response.data.length > 0) {
          const transcriptData = response.data[0]; // Get first transcript data
          if (transcriptData.deepgramText && transcriptData.deepgramText.length > 0) {
            setTranscriptData(transcriptData.deepgramText);

            // Save transcribe ID for later use in submit
            setTranscribeId(transcriptData._id);

            // Set available names from member details
            if (transcriptData.memberDetails && transcriptData.memberDetails.length > 0) {
              const memberNames = transcriptData.memberDetails.map((member: any) =>
                `${member.firstname} ${member.lastname}`
              );
              setAvailableNames(memberNames);
              // Store member details for ID mapping
              setMemberDetails(transcriptData.memberDetails);
              // Store group members for role and is_main info
              setGroupMembers(transcriptData.groupMembers || []);
            } else {
              setAvailableNames(defaultAvailableNames);
            }

            // Use labeledLambda for speaker mapping instead of extracting from transcript
            if (transcriptData.labeledLambda && transcriptData.labeledLambda.length > 0) {
              const initialMapping: { [key: string]: string } = {};
              transcriptData.labeledLambda.forEach((speaker: string) => {
                // Use labeledByTherapist as default value if exists, otherwise empty
                const labeledValue = transcriptData.labeledByTherapist?.[speaker];
                if (labeledValue) {
                  // Handle both old format (string) and new format (object with _id)
                  initialMapping[speaker] = typeof labeledValue === 'string' ? labeledValue : labeledValue._id || "";
                } else {
                  initialMapping[speaker] = "";
                }
              });
              setSpeakerMapping(initialMapping);
            } else {
              // Fallback to extracting speakers from transcript if no labeledLambda
              const speakers = extractSpeakersFromTranscript(transcriptData.deepgramText);
              const initialMapping: { [key: string]: string } = {};
              speakers.forEach(speaker => {
                initialMapping[speaker] = ""; // Default to empty for selection
              });
              setSpeakerMapping(initialMapping);
            }
            setIsLoadingTranscript(false);
            return;
          }
        }
      } catch (error) {
        console.error("Error loading transcript:", error);
        toast.error("Failed to load transcript data", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
      }
    }

    // If no real data available, use mock data
    toast.info("Using mock transcript data for demonstration", {
      position: toast.POSITION.TOP_RIGHT,
      className: "foo-bar",
    });

    const mockData = getMockTranscriptData();
    setTranscriptData(mockData);
    setAvailableNames(defaultAvailableNames);

    // Extract unique speakers from mock transcript
    const speakers = extractSpeakersFromTranscript(mockData);
    // Initialize speaker mapping with empty values
    const initialMapping: { [key: string]: string } = {};
    speakers.forEach(speaker => {
      initialMapping[speaker] = ""; // Default to empty for selection
    });
    setSpeakerMapping(initialMapping);
    setIsLoadingTranscript(false);
  };

  const extractSpeakersFromTranscript = (transcript: string[]): string[] => {
    const speakers = new Set<string>();
    transcript.forEach(line => {
      // Look for pattern "speaker:" at the beginning of line
      const match = line.match(/^([^:]+):/);
      if (match) {
        speakers.add(match[1].trim());
      }
    });
    return Array.from(speakers);
  };

  const handleSpeakerMappingChange = (originalSpeaker: string, newName: string) => {
    setSpeakerMapping(prev => ({
      ...prev,
      [originalSpeaker]: newName
    }));
    setValidationError(""); // Clear validation error when user makes changes
  };

  const validateMapping = () => {
    const mappedValues = Object.values(speakerMapping).filter(value => value !== "");
    const uniqueValues = new Set(mappedValues);

    // Check if at least one speaker is mapped
    if (mappedValues.length === 0) {
      setValidationError("Please map at least one speaker to a name.");
      return false;
    }

    // Check for duplicates
    if (mappedValues.length !== uniqueValues.size) {
      setValidationError("Each speaker must be mapped to a different person. No duplicates allowed.");
      return false;
    }

    return true;
  };

  const handleSubmitMapping = async () => {
    if (validateMapping()) {
      setIsSubmittingMapping(true);
      try {
        // Transform speakerMapping to new format with group member info
        const transformedMapping: { [key: string]: any } = {};
        Object.entries(speakerMapping).forEach(([speaker, userId]) => {
          if (userId !== "") {
            transformedMapping[speaker] = getGroupMemberInfo(userId);
          } else {
            transformedMapping[speaker] = "";
          }
        });

        // Get diagnosisnotes_id from props.transcribeData
        const diagnosisNotesId = props.transcribeData.diagnosisNoteId;

        // Call API to save speaker mapping with new format and diagnosisnotes_id
        const response = await VideoChatService.updateTranscribeLabeledByTherapist(transcribeId, transformedMapping, diagnosisNotesId);

        if (response.success) {
          setIsMappingSubmitted(true);
          setValidationError("");
          toast.success("Your note has been generated successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
          });
          // Close the modal after successful submission
          closeTestModal();
        } else {
          toast.error("Failed to save speaker mapping", {
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
          });
        }
      } catch (error) {
        console.error("Error saving speaker mapping:", error);
        toast.error("Error occurred while saving speaker mapping", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
      } finally {
        setIsSubmittingMapping(false);
      }
    }
  };

  const getAvailableOptions = (currentSpeaker: string) => {
    const usedNames = Object.entries(speakerMapping)
      .filter(([speaker, name]) => speaker !== currentSpeaker && name !== "")
      .map(([, name]) => name);

    return availableNames.filter(name => !usedNames.includes(name));
  };

  const formatSpeakerName = (speakerName: string) => {
    // Check if the speaker name is just a number (0, 1, 2, etc.)
    if (/^\d+$/.test(speakerName)) {
      return `User ${speakerName}`;
    }
    return speakerName;
  };

  // Helper function to get member name by ID
  const getMemberNameById = (id: string) => {
    const member = memberDetails.find(m => m._id === id);
    return member ? `${member.firstname} ${member.lastname}` : id;
  };

  // Helper function to get member ID by name
  const getMemberIdByName = (name: string) => {
    const member = memberDetails.find(m => `${m.firstname} ${m.lastname}` === name);
    return member ? member._id : name;
  };

  // Helper function to get group member info by user ID
  const getGroupMemberInfo = (userId: string) => {
    const groupMember = groupMembers.find(gm => gm.userId === userId);
    return groupMember ? {
      _id: userId,
      is_main: groupMember.is_main,
      role: groupMember.role
    } : {
      _id: userId,
      is_main: false,
      role: "MEMBER"
    };
  };

  const renderTranscriptWithMapping = () => {
    // Limit to first 20 messages
    const limitedTranscriptData = transcriptData.slice(0, 20);

    return limitedTranscriptData.map((line, index) => {
      const match = line.match(/^([^:]+):\s*(.*)$/);
      if (match) {
        const originalSpeaker = match[1].trim();
        const message = match[2].trim();
        const mappedSpeaker = isMappingSubmitted && speakerMapping[originalSpeaker]
          ? getMemberNameById(speakerMapping[originalSpeaker])
          : formatSpeakerName(originalSpeaker);

        return (
          <Card key={index} className="mb-2">
            <CardBody className="py-2">
              <div className="d-flex">
                <strong className="text-primary me-2">{mappedSpeaker}:</strong>
                <span>{message}</span>
              </div>
            </CardBody>
          </Card>
        );
      } else {
        // Handle lines without speaker format
        return (
          <Card key={index} className="mb-2">
            <CardBody className="py-2">
              <span className="text-muted">{line}</span>
            </CardBody>
          </Card>
        );
      }
    });
  };

  return (
    <div>
      {showTypeSelectModal && <NoteTypeSelectModal setShowModal={slectTypeFunction} showModal={showTypeSelectModal} />}
      {showTypeSelectModalForViewEdit && <NoteTypeSelectModal setShowModal={slectTypeFunctionForViewEdit} showModal={showTypeSelectModalForViewEdit} />}
      {showDiagnosisNoteWithVersionModal && (
        <DiagnosisNoteVersionModal
          setShowModal={setShowDiagnosisNoteWithVersionModal}
          showModal={showDiagnosisNoteWithVersionModal}
          diagnosisNoteDataTherapist={diagnosisNoteWithVersionsData}
          diagnosisNoteDataAdmin={null}
          showDiagnosisFunction={props.showDiagnosisFunction}
          isAdmin={false}
          showDiagnosis={() => {}}
          handleClose={handleModalClose}
        />
      )}
      <CardBody className="custom-card1">
        <div className="note-div-sec1">
          <h5 className="font-size-15">&#9930; Session Treatment History</h5>

          <div className="note-div-sec2">
            {props?.transcribeData?.meetingId?.meetingId?.includes("Regular") && <div className="note-regular-call">Regular Call</div>}

            {props?.transcribeData?.meetingId?.meetingId?.includes("Twilio") && <div className="note-regular-call">Phone Call</div>}

            {props?.transcribeData?.mergedMeetings?.length > 0 && <div className="note-merge-sec">Merged</div>}
          </div>
        </div>

        {props?.transcribeData?.meetingId?.appointmentId && props?.transcribeData?.appointmentDetails ? (
          <h5 className="font-size-15">
            Appointment Start Time{" "}
            <span className="session-h5">{moment(props?.transcribeData.appointmentDetails?.start || null).format("YYYY-MM-DD h:mm:ss a")}</span> / Meeting
            Started At <span className="session-h5">{moment(props.transcribeData.meetingStartedTime || null).format("YYYY-MM-DD h:mm:ss a")}</span>
          </h5>
        ) : (
          <h5 className="font-size-15">
            Meeting Started At <span className="session-h5">{moment(props.transcribeData.meetingStartedTime || null).format("YYYY-MM-DD h:mm:ss a")}</span>
          </h5>
        )}

        {props.transcribeData?.meetingId.callingStatus && (
          <h5 className="font-size-15">
            Calling Status&nbsp;
            <span className={props.transcribeData?.meetingId.callingStatus + " session-h5"}>{props.transcribeData?.meetingId.callingStatus}</span>
          </h5>
        )}

        <div className="flex">
          {props?.transcribeData?.isMeetingTranscribe && props?.transcribeData?.meetingId?.callingStatus == "COMPLETED" && user?.role == Role.THERAPIST && (
            <a
              onClick={() => {
                if (
                  props?.transcribeData?.isMeetingTranscribe &&
                  props?.transcribeData?.meetingId?.callingStatus == "COMPLETED" &&
                  props?.transcribeData?.diagnosisNoteVersions &&
                  props?.transcribeData?.diagnosisNoteVersions?.length > 0 &&
                  user?.role == Role.THERAPIST
                ) {
                  setDiagnosisNoteWithVersionsData(props?.transcribeData);
                } else {
                  openDiagnosisNoteInitial();
                }
              }}
              className="btn btn-secondary s-h-btn"
            >
              View / Edit Notes
            </a>
          )}

          {user?.role == Role.THERAPIST && (
            <>
              {((props.transcribeData.meetingId != undefined && props.transcribeData.meetingId?.transcribingInProcess) || props.isCreating) && (
                <a>
                  <span className="btn bg-warning convert-pending-note s-h-btn"> Convert Pending </span>
                </a>
              )}

              {props?.transcribeData?.diagnosisNoteDetails?.updatedByTherapist == false && (
                <button className="btn btn-danger s-h-btn" onClick={deleteDiagnosisNoteCode} data-value1={props?.transcribeData._id}>
                  <img src={deleteIcon} className="ai-icon-size " />
                </button>
              )}

              {((!props?.transcribeData?.meetingId?.clientAllowedTranscribe ||
                !props?.transcribeData?.meetingId?.therapistAllowedTranscribe ||
                !props?.transcribeData?.meetingId?.firstSpeaker ||
                !props?.transcribeData?.meetingId?.transcribeCreated) &&
                (props?.transcribeData?.diagnosisNoteDetails?.updatedByTherapist == false &&
                props?.transcribeData?.meetingId?.callingStatus != "CANCELLED"
                )) && (
                  <div className="text-primary d-flex align-items-center mt-3">
                    <i className="bx bx-info-circle clarity-info" id="ai_info"></i>
                    <UncontrolledTooltip placement="right" target={"ai_info"}>
                      {!props?.transcribeData?.meetingId?.clientAllowedTranscribe 
                        ? "The client has not provided consent for AI-generated notes."
                        : !props?.transcribeData?.meetingId?.therapistAllowedTranscribe
                        ? "The therapist has not provided consent for AI-generated notes."
                        : !props?.transcribeData?.meetingId?.firstSpeaker
                        ? "No conversation has been detected yet."
                        : "The transcription is still being processed."}
                    </UncontrolledTooltip>
                  </div>
              )}

              {props?.transcribeData?.meetingId?.clientAllowedTranscribe &&
                props?.transcribeData?.meetingId?.therapistAllowedTranscribe &&
                props?.transcribeData?.diagnosisNoteDetails?.updatedByTherapist == false &&
                props?.transcribeData?.meetingId?.firstSpeaker &&
                props?.transcribeData?.meetingId?.transcribeCreated &&
                !props?.transcribeData?.meetingId?.isGroupCall && (
                  <a>
                    <span className="btn btn-secondary btn-black1 convert-pending-note s-h-btn " onClick={() => genarateAiNoteFunction()}>
                      <img src={AiIcon} className="ai-icon-size me-1" />
                      {props?.transcribeData?.diagnosisNoteDetails?.noteType
                        ? props?.transcribeData?.diagnosisNoteDetails?.noteType === AINotesType.PIE
                          ? "Generate PIE note with AI"
                          : "Generate SOAP note with AI"
                        : user?.aiNotesType
                          ? user?.aiNotesType === AINotesType.PIE
                            ? "Generate PIE note with AI"
                            : "Generate SOAP note with AI"
                          : "Generate note with AI"}
                    </span>
                  </a>
                )}

              {props?.transcribeData?.meetingId?.isGroupCall && 
                props?.transcribeData?.diagnosisNoteDetails?.updatedByTherapist == false && 
                props?.transcribeData?.meetingId?.callingStatus == "COMPLETED" && (
                <button className="btn btn-info s-h-btn" onClick={handleTestClick}>
                  <img src={AiIcon} className="ai-icon-size me-1" />
                  {/* <i className="fa fa-flask mr-1"></i>  */}
                  Generate PIE note group call with AI
                </button>
              )}
            </>
          )}
          {user?.role == Role.THERAPIST &&
            props?.transcribeData?.meetingId?.callingStatus == "COMPLETED" &&
            !props.transcribeData?.subTherapistId &&
            props?.transcribeData?.diagnosisNoteDetails?.updatedByTherapist == true && (
              <button className="btn btn-success s-h-btn" onClick={() => handleOpenShareNote()}>
                <i className="fa fa-share-alt f-16"></i>
              </button>
            )}

          {/* {user?.role == Role.CLIENT && (
            <>
              { !props.isCreating &&
                props.transcribeData.meetingId != undefined &&
                props.transcribeData.meetingId.recordingSharedWithClient &&
                !props.transcribeData.meetingId.transcribingInProcess &&
                props.transcribeData.meetingId.transcribeCreated &&
                props.transcribeData.meetingId.recordingAllowed &&
                props.transcribeData.meetingId.recordingAllowed == true &&
                props.transcribeData.meetingId.audioFiles &&
                props.transcribeData.meetingId.audioFiles.length != 0 &&
                props.transcribeData.meetingId.audioFiles[0] &&
                props.transcribeData.meetingId.audioFiles[0].url &&
                (
                  <a>
                    {props.transcribeData.meetingId.audioFiles?.map((trs: any, index: any) => {
                      return (
                        <span
                          key={index}
                          onClick={() => {
                           props.showAudioFunction(trs._id, true);
                          }}
                          className="btn bg-success convert-pending-note s-h-btn"
                        >
                          {index == 0 ? "View Recording" : "View Recording" + (index + 1)}
                        </span>
                      );
                    })}
                  </a>
                )}
            </>
          )} */}

          {user?.role == Role.CLIENT && (
            <>
              {!props.isCreating &&
                props.transcribeData.meetingId != undefined &&
                props.transcribeData.meetingId.recordingSharedWithClient &&
                !props.transcribeData.meetingId.transcribingInProcess &&
                props.transcribeData.meetingId.transcribeCreated &&
                props.transcribeData.meetingId.recordingAllowed &&
                props.transcribeData.meetingId.recordingAllowed == true &&
                props.transcribeData.meetingId?.s3AudioPath && (
                  <a>
                    <span
                      onClick={() => {
                        props.showAudioFunction(props.transcribeData.meetingId._id, props.transcribeData.meetingId?.s3AudioPath, true);
                      }}
                      className="btn bg-success convert-pending-note s-h-btn"
                    >
                      view Record
                    </span>
                  </a>
                )}
            </>
          )}
        </div>

        {!props?.transcribeData?.meetingId?.transcribeCreated && props?.transcribeData?.meetingId?.s3AudioPath && (
          <h5 className="font-size-15 pt-2">
            <span className="text-success">Transcribe will be generated within two minutes.</span>
          </h5>
        )}

        {user?.role != Role.CLIENT && (
          <div className="merge-check-box">
            <div className="checkbox-wrapper-13">
              <input
                type="checkbox"
                name={props.transcribeData._id}
                id={props.transcribeData._id}
                onChange={e => {
                  handleCheckBoxChange({ target: { name: e.target.name, value: e.target.checked } });
                }}
              />
            </div>
          </div>
        )}
      </CardBody>

      {showAiGeneratedPopup && (
        <AIGeneratedNote
          OpenAiModel={showAiGeneratedPopup}
          transcribeData={props.transcribeData}
          closeModelFunction={handleChildFunction}
          saveNote={saveNote}
        />
      )}

      {showPIENote && (
        <AIGeneratePieNoteNew OpenAiModel={showPIENote} transcribeData={props.transcribeData} closeModelFunction={closePIENoteFunction} saveNote={saveNote} />
      )}

      {openShareModal && (
        <NoteShareTherapistModal showModal={openShareModal} setShowModal={setOpenShareModal} noteData={props.transcribeData} onShare={onShare} />
      )}

      {showTestModal && (
        <Modal isOpen={showTestModal} toggle={closeTestModal} size="lg" centered>
          <ModalHeader toggle={closeTestModal}>Transcript Speaker Mapping</ModalHeader>
          <ModalBody>
            {isLoadingTranscript ? (
              <div className="text-center p-4">
                <Spinner className="bouncer" />
                <p className="mt-2">Loading transcript...</p>
              </div>
            ) : (
              <div>
                {/* Speaker Mapping Section */}
                {Object.keys(speakerMapping).length > 0 && !isMappingSubmitted && (
                  <div className="mb-4">
                    <h5 className="mb-3">Speaker Mapping</h5>
                    <p className="text-muted small mb-3">Map the original speakers to actual names:</p>

                    {validationError && (
                      <Alert color="danger" className="mb-3">
                        {validationError}
                      </Alert>
                    )}

                    {Object.keys(speakerMapping).map(originalSpeaker => (
                      <FormGroup key={originalSpeaker} className="row mb-3 align-items-center">
                        <div className="col-md-4">
                          <Label className="form-label mb-0">
                            <strong>{formatSpeakerName(originalSpeaker)}</strong> →
                          </Label>
                        </div>
                        <div className="col-md-8">
                          <Input
                            type="select"
                            value={speakerMapping[originalSpeaker]}
                            onChange={(e) => handleSpeakerMappingChange(originalSpeaker, e.target.value)}
                            className="form-control-sm"
                          >
                            <option value="">Select a person...</option>
                            {memberDetails.map(member => (
                              <option key={member._id} value={member._id}>
                                {member.firstname} {member.lastname}
                              </option>
                            ))}
                          </Input>
                        </div>
                      </FormGroup>
                    ))}

                    <div className="text-center mt-4">
                      <Button
                        color="primary"
                        onClick={handleSubmitMapping}
                        className="px-4"
                        disabled={isSubmittingMapping}
                      >
                        {isSubmittingMapping ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generating...
                          </>
                        ) : (
                          "Confirm and generate AI note"
                        )}
                      </Button>
                    </div>
                    <hr className="my-4" />
                  </div>
                )}

                {/* Show mapping summary after submission */}
                {isMappingSubmitted && (
                  <div className="mb-4">
                    <h5 className="mb-3">Speaker Mapping Applied</h5>
                    <div className="bg-light p-3 rounded">
                      {Object.entries(speakerMapping)
                        .filter(([, mapped]) => mapped !== "") // Only show mapped speakers
                        .map(([original, mapped]) => (
                        <div key={original} className="d-flex justify-content-between mb-1">
                          <span><strong>{formatSpeakerName(original)}</strong></span>
                          <span className="text-primary">{getMemberNameById(mapped)}</span>
                        </div>
                      ))}
                    </div>
                    <div className="text-center mt-3">
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => setIsMappingSubmitted(false)}
                      >
                        Edit Mapping
                      </Button>
                    </div>
                    <hr className="my-4" />
                  </div>
                )}

                {/* Transcript Display Section */}
                <div>
                  <h5 className="mb-3">Transcript</h5>
                  {transcriptData.length > 20 && (
                    <div className="alert alert-info mb-3">
                      <small>Showing first 20 messages of {transcriptData.length} total messages</small>
                    </div>
                  )}
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {renderTranscriptWithMapping()}
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default TranscribeHistoryCard;
